<template>
  <div class="wrap">
    <!-- 头部 -->
    <headTop :toggle="3"></headTop>
    <!-- 中间内容 -->
    <div class="specialistContent">
      <div style="padding:0.2em 3em 0.8em 3em">
        <!-- 右侧内容 -->
        <div class="specialistContent_right">
          <div class="specialistContent_right_title">
            <div class="title">企业展馆</div>
          </div>
          <ul class="listBox">
              <li v-for="item in listArr" :key="item.id"  @click="goToDetail(item.id)">
                <img :src="$store.getters.imgUrl+item.logo" alt v-if="item.logo" />
                <!-- <img src="@/assets/image/equipment/3.png" alt="" v-else> -->
                <div class="NoLogoBox" v-else>
                  <span>{{item.name}}</span>
                </div>
                <span class="title">{{item.name}}</span>
                <!-- <span class="info">{{item.info}}</span> -->
                <div class="detail">
                  <span>详情</span>
                  <img src="@/assets/image/index/moreO.png" alt  style="border:none"/>
                </div>
              </li>
              <li
                v-show="listArr.length%5>0"
                v-for="item in (5-listArr.length%5)"
                :key="item"
                class="addLi"
              ></li>
            </ul>
        </div>
      </div>
      <div class="footer">
        <footCode></footCode>
      </div>
    </div>
  </div>
</template>
<script>
import footCode from "../../components/footCode";
import headTop from "../../components/HeadTop";
import Pagination from "@/components/pagination";
export default {
  name: "equipment",
  components: {
    footCode,
    headTop,
    Pagination,
  },
  data() {
    return {
      listArr: [],
      total: "", // 条数
      current: "", // 第几页
      limit: 12,
      page: 1,
      scrollTop: "",
    };
  },
  mounted() {
    this.indexInit();
  },
  activated() {
     this.$nextTick(() => {
      //恢复滚动高度
      console.log(this.$store.state.scrollTop);
      document
        .getElementsByClassName("specialistContent")[0]
        .scrollTo(0, this.$store.state.scrollTop);
    });
        
  },
 

    beforeRouteLeave(to, from, next) {
      this.scrollTop =document.getElementsByClassName("specialistContent")[0].scrollTop;
      this.$store.commit("changeScrollTop", this.scrollTop);
      console.log(this.scrollTop,"leave page");
      next();
    },
  methods: {
    indexInit() {
      // 云课堂分页
      this.ajaxUtil({
        method: "get",
        // url: '/apiAjax/api/home/index',
        url:
          this.$store.state.axiosUrl + '/api/home/getAllEnterpriseHall',
        // params: {},
      }).then((res) => {
        this.listArr = res.data;
      });
    },
    goToDetail(id) {
      this.$router.push({
        path: "/enterprise/enterpriseDetail",
        query: { id },
      });
    },
  },
};
</script>
<style scoped lang="less">
@import url("~@/assets/css/index.less");
.wrap {
  display: flex;
  flex-direction: column;
  min-width: 12.8em;
}
.specialistContent {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  min-height: 110vh;
  // overflow: auto;
  .specialistContent_right {
    color: #333;
    margin-left: 2em;
    margin-top: 0.1em;
    font-size: 0.18em;
    flex: 1;
    .specialistContent_right_title {
      font-size: 0.2em;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 1em;
      border-bottom: 1px solid #e5e5e5;
      div {
        padding-bottom: 1em;
      }
      .title {
        color: #2579bf;
        font-size: 16px;
        padding-bottom: 5px;
        border-bottom: 4px solid #2579bf;
      }
    }
    //   列表
    .listBox {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        border: 1px solid #eee;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        width: 19%;
        padding-bottom: 0.5em;
        margin-top: 20px;
        cursor: pointer;
        .title {
          color: #2579bf;
          font-size: 0.85em;
          height: 3.5em;
        }
        img {
          height: 122px;
          width: 100%;
          border: 1px solid #2579BF;
        }
        span {
          font-size: 0.28em;
          padding: 5px 10px;
        }
        .company {
          position: absolute;
          top: 96px;
          left: 0;
          width: 100%;
          white-space: nowrap;
          background-color: rgba(0, 0, 0, 0.5);
          color: #fff;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: center;
        }
        .info {
          padding: 0px 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
        //详情
        .detail {
          font-size: 0.16em;
          color: #ff7920;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 0 10px;
          cursor: pointer;
          span {
            padding: 0;
            margin-right: 5px;
          }
          img {
            height: 10px;
            width: 10px;
          }
        }
      }
    }
  }
}
.footer {
  width: 100%;
  // margin-top: 0.2em;
}
.titlePosition {
  font-size: 0.15em;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  color: #666;
}
.box {
  display: flex;
}
.NoLogoBox {
  background-image: url("~@/assets/image/equipment/3.png");
  height: 122px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: hzgb;
  align-items: center;
  text-align: -webkit-center;
  span{
    margin-top: -20px;
    font-size: 14px !important;
    font-weight: 600;
    letter-spacing:3px
  }
}
.addLi {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/enterprise/index.vue